// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'atom... Remove this comment to see the full error message
import { deref, unwatch, watch } from 'atom';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import { isResolved } from 'reference-resolvers/utils';
import FilterOperatorType from 'customer-data-filters-ui/components/propTypes/FilterOperatorType';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
const getFieldLabel = (reference, value) => reference ? reference.label : value;
export default class DisplayValueProperty extends PureComponent {
  constructor() {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 1-2 arguments, but got 0.
    super();
    this.handleReferenceChange = reference => {
      if (isResolved(reference)) {
        this.setState({
          reference
        });
      }
    };
    this.state = {
      reference: null
    };
    this.referenceAtom = null;
  }
  componentDidMount() {
    this.mountResolver();
  }
  componentDidUpdate(prevProps) {
    const {
      value
    } = this.props;
    if (prevProps.value !== value) {
      this.mountResolver();
    }
  }
  componentWillUnmount() {
    if (this.referenceAtom) {
      unwatch(this.referenceAtom, this.handleReferenceChange);
    }
  }
  mountResolver() {
    const {
      getFamilyValueResolver,
      operator,
      value
    } = this.props;
    const resolver = getFamilyValueResolver(operator);
    if (resolver && typeof resolver.byId !== 'function') {
      Raven.captureException(new Error(`[Expected a reference resolver] resolver does not have 'byId' function; operator.field: ${JSON.stringify(operator.field)}`));
    }
    if (resolver && resolver.byId) {
      if (this.referenceAtom) {
        unwatch(this.referenceAtom, this.handleReferenceChange);
      }
      this.referenceAtom = resolver.byId(value);
      watch(this.referenceAtom, this.handleReferenceChange);
      this.handleReferenceChange(deref(this.referenceAtom));
    }
  }
  render() {
    const {
      value
    } = this.props;
    const {
      reference
    } = this.state;
    const propertyLabel = getFieldLabel(reference, value);
    return /*#__PURE__*/_jsx("span", {
      children: propertyLabel
    });
  }
}
DisplayValueProperty.propTypes = {
  getFamilyValueResolver: PropTypes.func.isRequired,
  operator: FilterOperatorType.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};